import React, { useState, useEffect } from 'react';
import { Button, Form, Input, Space, Table, Switch, InputNumber, Radio, DatePicker,App } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import type { Dayjs } from 'dayjs';
import styles from './StorePublishProductStep2.module.scss';
import { IFormDataAll, ISkuList} from '../../types';
import { useTranslation } from 'react-i18next';
export interface StorePublishProductStep2Props {
  onNext?: (submitData: any) => void;
  onPrev?: () => void;
  formData?: IFormDataAll; // 使用导入的接口
}


    


// 产品发布第二步：销售信息
const StorePublishProductStep2: React.FC<StorePublishProductStep2Props> = ({
  onNext,
  onPrev,
  formData // 接收formData属性
}) => {

  const { t, i18n } = useTranslation();

  const { message } = App.useApp();
  const [form] = Form.useForm();
  const [dataSource, setDataSource] = useState<ISkuList[]>([]);
  const [launchOption, setLaunchOption] = useState<string>('schedule');

  // 初始化数据
  useEffect(() => {
    if (formData?.product_sku_values && formData?.product_sku_values.length > 0) {

      const initialData = formData?.product_sku_values.map(item => ({
        ...item,
        is_on_shelf: item.is_on_shelf || false,
        product_price: item.product_price || 0,
        product_stock: item.product_stock || 0
      }));

      //设置表单默认值
      setDataSource(initialData);

      setLaunchOption(formData.launch_option || 'schedule');
    }
  }, [formData]);

  

  // 处理价格变更
  const handlePriceChange = (value: number | null, index: number) => {
    setDataSource(prevData => {
      const newData = [...prevData];
      newData[index] = {
        ...newData[index],
        product_price: value || 0
      };
      return newData;
    });
  };

  // 处理库存变更
  const handleInventoryChange = (value: number | null, index: number) => {
    setDataSource(prevData => {
      const newData = [...prevData];
      newData[index] = {
        ...newData[index],
        product_stock: value || 0
      };
      return newData;
    });
  };

  // 处理上架状态变更
  const handleListingChange = (checked: boolean, index: number) => {
    setDataSource(prevData => {
      const newData = [...prevData];
      newData[index] = {
        ...newData[index],
        is_on_shelf: checked
      };
      return newData;
    });
  };

  // 返回上一步
  const handlePrev = () => {
   
    onPrev && onPrev();
  };

  // 处理提交
  const handleSubmit = () => {

    //校验表单

    //校验sku列表
    if(dataSource){

      for(let i = 0; i < dataSource.length; i++){
        if(!dataSource[i].product_price){
          message.error('Price cannot be 0');
          return;
        }
      }
    }


   

   

    form.validateFields().then(values => {
      const submitData = {
        ...values,
        product_sku_values: dataSource,
        launch_option: launchOption,
      };
      console.log('Form values:', submitData);
      onNext && onNext(submitData);
    }).catch(err => {
      console.error('Validation failed:', err);
    });
  };

  // 表格列配置
  const columns = [
    {
      title: t('StorePublishProductStep2.AttributeClassification'),
      dataIndex: 'specs',
      key: 'specs',
      render: (specs: any[]) => (
        <div>
          {specs.map((spec, index) => (
            <div key={index}>{spec.lable}: {spec.value}</div>
          ))}
        </div>
      ),
    },
    {
      title: t('StorePublishProductStep2.Price'),
      dataIndex: 'product_price',
      key: 'product_price',
      render: (text: number, record: ISkuList, index: number) => (
        <InputNumber
          min={0}
          defaultValue={text}
          onBlur={(e) =>{
            const value = parseFloat(e.target.value);
            if(value){
              handlePriceChange(value, index);
            }
          }}
          className={styles['price-input']}
        />
      ),
    },
    {
      title: t('StorePublishProductStep2.Inventory'),
      dataIndex: 'product_stock',
      key: 'product_stock',
      render: (text: number, record: ISkuList, index: number) => (
        <InputNumber
          min={0}
          defaultValue={text}
          onBlur={(e) =>{
            const value = parseFloat(e.target.value);
            if(value){
              handleInventoryChange(value, index);
            }
          }}
          className={styles['inventory-input']}
        />
      ),
    },
    {
      title: t('StorePublishProductStep2.Whethertolist'),
      dataIndex: 'is_on_shelf',
      key: 'is_on_shelf',
      render: (checked: boolean, record: ISkuList, index: number) => (
        <Switch
          checked={checked}
          onChange={(checked) => handleListingChange(checked, index)}
        />
      ),
    },
  ];

  return (
    <div className={styles['store-publish-product-step2']}>
      <div className={styles['main-title']}>{t('StorePublishProductStep2.SalesInformation')}</div>
      
      <Form form={form} layout="vertical">
        {/* SKU表格 */}
        <div className={styles['sku-table-container']}>
          <Table
            dataSource={dataSource}
            columns={columns}
            pagination={false}
            rowKey={(record) => record.product_sku_id?.toString() || Math.random().toString(36).substring(2, 10)}
            className={styles['sku-table']}
            components={{
              body: {
                cell: (props: any) => {
                  // 为移动端添加标签属性
                  const columnTitle = columns[props.index]?.title;
                  return <td {...props} data-label={columnTitle} />;
                },
              },
            }}
          />
        </div>


       

        {/* 上架日期 */}
        <div className={styles['launch-date-container']}>
          <div className={styles['section-title']}>* {t('StorePublishProductStep2.LaunchDate')}</div>
          <Radio.Group 
            value={launchOption} 
            onChange={(e) => setLaunchOption(e.target.value)}
            className={styles['launch-options']}
          >
            <Radio value="immediate">{t('StorePublishProductStep2.ListImmediately')}</Radio>
            <Radio value="schedule">{t('StorePublishProductStep2.ScheduleListing')}</Radio>
            <Radio value="warehouse">{t('StorePublishProductStep2.PutIntoWarehouse')}</Radio>
          </Radio.Group>

        </div>

        {/* 按钮区域 */}
        <div className={styles['button-container']}>
          <Button
            className={styles['cancel-button']}
            onClick={handlePrev}
          >
            {t('common.Prev')}
          </Button>
          <Button
            type="primary"
            className={styles['next-button']}
            onClick={handleSubmit}
          >
            {t('common.Next')}
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default StorePublishProductStep2; 